import _toConsumableArray from "/var/jenkins_home/workspace/tingle.f418dd7e-8301-4eb7-bd6c-ad3162510800/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.f418dd7e-8301-4eb7-bd6c-ad3162510800/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins_home/workspace/tingle.f418dd7e-8301-4eb7-bd6c-ad3162510800/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.f418dd7e-8301-4eb7-bd6c-ad3162510800/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";
import React from 'react';
import { LoadingIndicator, IconPlay, IconArrowRight } from '@spotify-internal/encore-web';
import { useRouter } from 'next/router';
import { useTracking } from '../Tracking';
import { ContentfulImage } from '../Contentful/ContentfulImage';
import { itemToSearchHit } from '../Search/content';
import { formatText, fixHref } from '../utils';
import { DEFAULT_SOCIAL_CARD } from '../Layout/PageHead';
import { StyledLink, Headline, Subtext, CTALink, Item, ItemList, ImageWrapper, ItemLabel, ItemTitle, ItemText, LoadMoreButton, LoadMoreButtonWrapper } from './index.styles';
import { Box, Supertext } from '../ui';
import { useLocale, useT } from '@mrkt/features/i18n';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Hide entire module when box will be empty
export var StyledBox = styled(Box).withConfig({
  displayName: "ContentGrid__StyledBox",
  componentId: "lgrdme-0"
})(["height:", ";padding:", ";opacity:", ";"], function (props) {
  return props.displayModule ? '' : '0px';
}, function (props) {
  return props.displayModule ? '' : '0px';
}, function (props) {
  return props.displayModule ? '' : '0%';
});
export var ContentGrid = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var supertext = _ref.supertext,
      headline = _ref.headline,
      subtext = _ref.subtext,
      ctaText = _ref.ctaText,
      ctaLink = _ref.ctaLink,
      trackCategory = _ref.trackCategory,
      _ref$items = _ref.items,
      initialItems = _ref$items === void 0 ? [] : _ref$items,
      _ref$featuredItems = _ref.featuredItems,
      featuredItems = _ref$featuredItems === void 0 ? 0 : _ref$featuredItems,
      _ref$getPageItems = _ref.getPageItems,
      getPageItems = _ref$getPageItems === void 0 ? function () {
    return Promise.resolve([]);
  } : _ref$getPageItems,
      _ref$hasNextPage = _ref.hasNextPage,
      hasNextPage = _ref$hasNextPage === void 0 ? function () {
    return false;
  } : _ref$hasNextPage,
      _ref$placeholders = _ref.placeholders,
      placeholders = _ref$placeholders === void 0 ? true : _ref$placeholders;
  var t = useT();
  var locale = useLocale();
  var router = useRouter();

  var _useTracking = useTracking(),
      sendEvent = _useTracking.sendEvent;

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      items = _React$useState2[0],
      setItems = _React$useState2[1];

  var page = React.useRef(1);

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      pageLoading = _React$useState4[0],
      setPageLoading = _React$useState4[1];

  React.useEffect(function () {
    var newItems = initialItems.map(function (item) {
      return itemToSearchHit(item, locale);
    }).filter(Boolean);
    setItems(newItems);
  }, [initialItems]);

  var loadNextPage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var pageItems, newItems;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              setPageLoading(true);
              sendEvent({
                eventCategory: "Frodor - ".concat(trackCategory),
                eventAction: 'click',
                eventLabel: "Load More - Page ".concat(page.current + 1)
              });
              _context.next = 5;
              return getPageItems(++page.current);

            case 5:
              pageItems = _context.sent;
              newItems = pageItems.map(function (item) {
                return itemToSearchHit(item, locale);
              }).filter(Boolean);
              setItems([].concat(_toConsumableArray(items), _toConsumableArray(newItems)));
              setPageLoading(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadNextPage(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs(StyledBox, {
    ref: ref,
    displayModule: (items === null || items === void 0 ? void 0 : items.length) !== 0,
    children: [supertext && /*#__PURE__*/_jsx(Supertext, {
      children: supertext
    }), headline && /*#__PURE__*/_jsx(Headline, {
      children: headline
    }), subtext && /*#__PURE__*/_jsx(Subtext, {
      dangerouslySetInnerHTML: {
        __html: formatText(subtext)
      }
    }), ctaText && ctaLink && /*#__PURE__*/_jsxs(CTALink, {
      href: fixHref(ctaLink),
      track: [trackCategory, "CTA Link - ".concat(ctaText)],
      children: [ctaText, /*#__PURE__*/_jsx(IconArrowRight, {
        iconSize: 16
      })]
    }), /*#__PURE__*/_jsx(ItemList, {
      children: !items && /*#__PURE__*/_jsx(LoadingIndicator, {}) || items.map(function (item, index) {
        return /*#__PURE__*/_jsxs(Item, {
          featured: index < featuredItems,
          children: [/*#__PURE__*/_jsxs(StyledLink, {
            href: item.url,
            track: [trackCategory, "Content Link - [".concat(item.contentType, "]: ").concat(item.title)],
            "aria-label": "".concat(t('FRODOR_a55c16', 'Go to {title}', 'Go to means to click a link to follow it', {
              title: item.title
            })),
            children: [/*#__PURE__*/_jsx(ImageWrapper, {
              video: item.contentType === 'video' || item.contentType === 'videoPage',
              featured: index < featuredItems,
              children: item.image && /*#__PURE__*/_jsx(ContentfulImage, {
                asset: item.image,
                placeholder: placeholders,
                children: /*#__PURE__*/_jsx(IconPlay, {})
              }) ||
              /*#__PURE__*/
              // placeholder if no image, for now
              _jsx("img", {
                "data-src": DEFAULT_SOCIAL_CARD,
                alt: "".concat(t('FRODOR_bfbc75', 'Spotify for Artists', ''), " - ").concat(item.contentType),
                className: "lazyload"
              })
            }), item.label && /*#__PURE__*/_jsx(ItemLabel, {
              children: item.label
            }), item.title && /*#__PURE__*/_jsx(ItemTitle, {
              children: item.title
            })]
          }), item.description && /*#__PURE__*/_jsx(ItemText, {
            children: item.description
          })]
        }, item.id);
      })
    }), hasNextPage(page.current) && Boolean(items === null || items === void 0 ? void 0 : items.length) || router.query && router.query._lqa === 'loadMore' && /*#__PURE__*/_jsx(LoadMoreButtonWrapper, {
      children: pageLoading ? /*#__PURE__*/_jsx(LoadingIndicator, {}) : /*#__PURE__*/_jsx(LoadMoreButton, {
        onClick: loadNextPage,
        children: t('FRODOR_CONTENT_GRID_LOAD_MORE', 'Load more', 'If clicked, this button will show the next page of content')
      })
    })]
  });
});